import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateTileStatus } from "@/services/review.service";
import { UpdateTileStatusRequest } from "@/types/review.types";

export const useUpdateTileStatus = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: UpdateTileStatusRequest) => updateTileStatus(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["reviews"] });
    },
  });
};
